import * as ActionType from "./contacts.type";

const initialState = {
  list: [],
  total: 0,
  detail: null,
  loading: false,
  error: null,
};

export const contactsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.CONTACTS_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case ActionType.CONTACTS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload || null,
      };
    case ActionType.GET_CONTACTS:
      return {
        ...state,
        list: action.payload.list,
        total: action.payload.total,
        loading: false,
      };
    case ActionType.GET_CONTACT_DETAIL:
      return {
        ...state,
        detail: action.payload,
        loading: false,
      };
    case ActionType.UPDATE_CONTACT_DETAIL: {
      const updated = action.payload;
      const nextList = Array.isArray(state.list)
        ? state.list.map((item) => (item?._id === updated?._id ? updated : item))
        : state.list;
      return {
        ...state,
        detail: updated,
        list: nextList,
        loading: false,
      };
    }
    default:
      return state;
  }
};
